export default __webpack_public_path__ + "svg/CompaniesLogos/logo_genetsis-group.svg?4350d49b";